import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../core/store/app.state';
import {clearRecipe, loadRecipes} from '../../../../core/store/recipe/recipe.actions';
import {
  getAllRecipes,
  getCurrentPageRecipe,
  getPageSizeRecipe,
  getTotalItemsRecipe,
  isLoadingListRecipe
} from '../../../../core/store/recipe/recipe.selectors';
import {IListRecipe} from '../../../../core/model/recipe/list-recipe.model';
import {ListUtilComponent} from '../../util/list-util.compoment';
import {Observable} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {ModalService} from '../../../services/util/modal.service';
import {AuthService} from '../../../services/auth/auth.service';
import {Visibility} from '../../../../core/model/recipe/visibility.model';
import {StateStorageService} from '../../../services/auth/state-storage.service';
import {SsrContext} from '../../../services/util/ssr-context.service';
import {takeUntil} from 'rxjs/operators';


@Component({
    selector: 'app-recipe-list-card-component',
    templateUrl: './recipe-list-card.component.html',
    styleUrls: ['./recipe-list-card.component.scss'],
    standalone: false
})
export class RecipeListCardComponent extends ListUtilComponent {

  dataSource: Observable<IListRecipe[]>;
  keyLoadStore = loadRecipes;
  keyRemoveStore = clearRecipe;
  sizePage = 9;
  form = new FormGroup({
    order: new FormControl('star,desc'),
  });
  @Input() visibility: Visibility[];
  @Input() domain: string;
  @Input() userId: string;
  @Input() forceTextFilter = '';
  @Input() order = 'star,desc';
  @Input() bgColor = false;
  @ViewChild('recipeListCard') idToUpAfterLoadPage: ElementRef;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected modalService: ModalService,
    public ssrContext: SsrContext,
    private stateStorageService: StateStorageService,
    protected authService: AuthService,
    protected store: Store<AppState>
  ) {
    super(router, route, authService);
    this.storeService = store;
  }

  onInit(): void {
    this.dataSource = this.store.select(getAllRecipes);
    this.totalItems = this.store.select(getTotalItemsRecipe);
    this.isLoading = this.store.select(isLoadingListRecipe);
    this.currentPage = this.store.select(getCurrentPageRecipe);
    this.pageSize = this.store.select(getPageSizeRecipe);

    this.route.queryParamMap
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (queryParams: ParamMap) => {
          const properties = queryParams.get('properties');
          const direction = queryParams.get('direction');
          if (properties && direction) {
            this.form.get('order').setValue(properties + ',' + direction);
          } else {
            this.form.get('order').setValue(this.order);
          }
        },
        error: err => console.error(err)
      });


    this.form.valueChanges.subscribe({
      next: (value) => {
        const data = value.order.split(',');
        this.sortData(data[0], data[1]);
      },
      error: (err) => console.error(err),
    });
  }

  getFilter(queryParams: ParamMap): any {
    const paramString = this.getParamString(queryParams.get('size'));
    const sort = this.getSort(queryParams) || [this.order];
    return {
      domain: this.domain && this.domain !== 'all' ? this.domain : this.route.snapshot.paramMap.get('domain'),
      userId: this.userId ? this.userId : '',
      difficulties: this.getParamArray(queryParams.get('difficultes')),
      times: this.getParamArray(queryParams.get('times')),
      visibilities: this.visibility,
      category: this.getParamString(queryParams.get('categorie')),
      subCategory: this.getParamString(queryParams.get('sousCategorie')),
      tags: this.getParamArray(queryParams.get('tags')),
      page: this.getParamString(queryParams.get('page')),
      size: paramString ? paramString : this.sizePage,
      sort: sort ? sort : ['star,desc']
    };
  }

  openModal(id: string): void {
    this.modalService.open(id);
  }

  closeModal(id: string): void {
    this.modalService.close(id);
  }

  closeModalLogin(id: string): void {
    this.closeModal(id);
    this.stateStorageService.storeUrl(this.router.url);
  }
}
